import murmurhash from 'murmurhash';

export const hashingData = (storeHash: any, data: any, paramName: string) => {
    if (data[paramName]) {
        const newHashItemsList = murmurhash.v3(JSON.stringify(data[paramName]));

        if (storeHash[paramName] === newHashItemsList) {
            delete data[paramName];
        } else {
            storeHash[paramName] = newHashItemsList;
        }
    }
};
